<template>
  <div>
    <div class="member-main-tab">
      <ul class="main-tab">
        <li class="active">学习计划</li>
      </ul>
    </div>
    <div class="member-main-body">
      <div class="score-table">
        <div class="score-tr">
          <div class="score-th">学期</div>
          <div class="score-th">课程名称</div>
          <div class="score-th">网络课堂</div>
          <div class="score-th">考试</div>
          <div class="score-th">最终成绩</div>
        </div>
        <div class="score-tr" v-for="(item, index) in dataList" :key="index">
          <div class="score-col">{{ item.Name }}</div>
          <div class="score-col">
            <div
              class="score-row"
              v-for="(course, ci) in item.resultList"
              :key="ci"
            >
              <div class="score-td">{{ course.CourseName }}</div>
              <div class="score-td">
                <a
                  href="javascript:;"
                  @click="getStudyCourseList(course)"
                  class="progress-btn"
                  >去学习</a
                >
              </div>
              <div class="score-td">
                <a
                  href="javascript:;"
                  v-if="course.count > 0"
                  @click="getExamCourseList(course)"
                  class="progress-btn"
                  >去考试</a
                >
                <span v-else>暂无考试</span>
              </div>
              <div class="score-td">
                {{ course.Score == null ? "--" : course.Score }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 去学习 -->
    <Modal
      v-model="studyModalVisible"
      title="选择网课学习"
      width="600"
      footer-hide
    >
      <ul class="course-list">
        <li v-for="(item, index) in studyCourseList" :key="index">
          <div class="course-name">
            「{{ item.CourseNo }}」{{ item.CourseName }}
          </div>
          <div class="course-btn">
            <router-link
              v-if="!item.umcOverdue"
              :to="{ name: 'CourseStudy', params: { cid: item.CourseID } }"
              target="_blank"
              title="开始学习"
            >
              <Button type="primary" long shape="circle">开始学习</Button>
            </router-link>
            <router-link
              v-else
              :to="{ name: 'CourseDetail', params: { id: item.productId } }"
              target="_blank"
              title="我要续费"
            >
              <Button type="primary" long shape="circle">我要续费</Button>
            </router-link>
          </div>
        </li>
      </ul>
    </Modal>

    <!-- 去考试 -->
    <Modal
      v-model="examModalVisible"
      title="选择网课模考"
      width="600"
      footer-hide
    >
      <ul class="course-list">
        <li v-for="(item, index) in examCourseList" :key="index">
          <div class="course-name">
            「{{ item.CourseNo }}」{{ item.CourseName }}
          </div>
          <div class="course-btn">
            <!-- <router-link
              v-if=""
              :to="{ name: 'CourseStudy', params: { cid: item.CourseID } }"
              target="_blank"
              title="开始学习"
            >
            </router-link> -->
            <Button
              v-if="!item.umcOverdue"
              @click="gotoExam(item.CourseID)"
              type="primary"
              long
              shape="circle"
              >进行考试</Button
            >
            <router-link
              v-else
              :to="{ name: 'CourseDetail', params: { id: item.productId } }"
              target="_blank"
              title="我要续费"
            >
              <Button type="primary" long shape="circle">我要续费</Button>
            </router-link>
          </div>
        </li>
      </ul>
    </Modal>
  </div>
</template>

<script>
import { siteMixin } from "../../utils/mixin";
import { custom } from "../../request/index";
export default {
  mixins: [siteMixin],
  data() {
    return {
      dataList: [],
      studyModalVisible: false,
      examModalVisible: false,
      studyCourseList: [
        {
          courseId: 23234,
          courseNo: "D0009",
          courseName: "政治经济学原理",
          umcOverdue: false,
        },
      ],
      examCourseList: [],
    };
  },
  watch: {
    srfId(newId) {
      this.getData();
    },
  },
  mounted() {
    this.setMetaData("学习计划");
    this.getData();
  },
  methods: {
    getData() {
      if (!this.srfId) return;
      custom.getCourseList(this.srfId, this.siteConfig.agencyId).then((res) => {
        //console.log("courseList", res);
        if (res.status === 1) {
          this.dataList = res.data;
        }
      });
    },
    getStudyCourseList(record) {
      custom.getStudyCourse(record.CourseId).then((res) => {
        if (res.status == 1) {
          this.studyCourseList = res.data;
          this.studyModalVisible = true;
        }
      });
    },
    getExamCourseList(record) {
      custom.getExamCourse(record.CourseId).then((res) => {
        if (res.status == 1) {
          this.examCourseList = res.data;
          this.examModalVisible = true;
        }
      });
    },
    gotoExam(courseId) {
      custom.getExamDate(courseId, this.srfId).then((res) => {
        console.log("examTime", res);
        if (res.data) {
          const startTime = new Date(Date.parse(res.data.startTime));
          const endTime = new Date(Date.parse(res.data.endTime));
          const nowTime = new Date();
          if (nowTime > endTime || nowTime < startTime) {
            this.$Modal.warning({
              title: "温馨提示",
              content: `请在指定的时间来参加模拟考试<br><br>本课程的模考日期是：<br>${res.data.startTime}至${res.data.endTime}`,
            });
            return;
          }
        }
        const jumpUrl = `/topic/course/study/${courseId}?e=x`;
        window.open(jumpUrl, "_blank");
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/var";
@import "../../assets/css/member-main.less";
.member-main-body {
  padding: 24px;
}
.score-table {
  border: 1px solid #ccc;
  border-radius: 6px;
  overflow: hidden;
  .score-tr {
    display: flex;
    margin-left: -1px;
    margin-top: -1px;
    .score-th {
      border-top: 1px solid #ccc;
      border-left: 1px solid #ccc;
      text-align: center;
      padding: 8px 10px;
      font-weight: bold;
      background: #f1f1f1;
      &:nth-child(1) {
        width: 100px;
      }
      &:nth-child(2) {
        width: 541px;
      }
      &:nth-child(3) {
        width: 100px;
      }
      &:nth-child(4) {
        width: 100px;
      }
      &:nth-child(5) {
        width: 80px;
      }
    }
    .score-col {
      text-align: center;
      &:nth-child(1) {
        border-top: 1px solid #ccc;
        border-left: 1px solid #ccc;
        width: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      &:nth-child(2) {
        width: 821px;
      }
      .score-row {
        display: flex;
        .score-td {
          padding: 8px 10px;
          border-top: 1px solid #ccc;
          border-left: 1px solid #ccc;
          .ellipsis();
          &:nth-child(1) {
            width: 541px;
          }
          &:nth-child(2) {
            width: 100px;
            // text-align: left;
          }
          &:nth-child(3) {
            width: 100px;
          }
          &:nth-child(4) {
            width: 80px;
          }
          .progress-bar {
            display: inline-block;
            vertical-align: middle;
            width: 180px;
          }
          .progress-btn {
            display: inline-block;
            vertical-align: middle;
            color: #0092e6;
          }
          .score-td-time {
            .inline-block();
            padding: 3px 10px;
            background-color: #0092e6;
            color: #fff;
            border-radius: 6px;
            min-width: 56px;
          }
        }
      }
    }
  }
}
.course-list {
  padding: 8px 12px 16px 8px;
  li {
    border-bottom: 1px dashed #ccc;
    display: flex;
    align-items: center;
    padding: 10px 0;
    .course-name {
      flex: 1;
      font-size: 16px;
    }
    .course-btn {
      width: 100px;
    }
  }
}
</style>
